var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M6.14171 18.3337H13.85C16.0917 18.3337 17.9084 16.517 17.9084 14.2753V6.97533C17.9084 4.73366 16.0917 2.91699 13.85 2.91699H6.14171C3.90004 2.91699 2.08337 4.73366 2.08337 6.97533V14.267C2.08337 16.517 3.90004 18.3337 6.14171 18.3337Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90833 5.24199C6.55833 5.24199 6.28333 4.95866 6.28333 4.61699V2.29199C6.28333 1.95033 6.55833 1.66699 6.90833 1.66699C7.25833 1.66699 7.53333 1.95033 7.53333 2.29199V4.60866C7.53333 4.95866 7.25833 5.24199 6.90833 5.24199Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0917 5.24199C12.7417 5.24199 12.4667 4.95866 12.4667 4.61699V2.29199C12.4667 1.94199 12.75 1.66699 13.0917 1.66699C13.4417 1.66699 13.7167 1.95033 13.7167 2.29199V4.60866C13.7167 4.95866 13.4417 5.24199 13.0917 5.24199Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.2913H8.59171V10.833C8.59171 10.4913 8.30837 10.208 7.96671 10.208C7.62504 10.208 7.34171 10.4913 7.34171 10.833V12.2913H5.83337C5.49171 12.2913 5.20837 12.5747 5.20837 12.9163C5.20837 13.258 5.49171 13.5413 5.83337 13.5413H7.34171V14.9997C7.34171 15.3413 7.62504 15.6247 7.96671 15.6247C8.30837 15.6247 8.59171 15.3413 8.59171 14.9997V13.5413H10C10.3417 13.5413 10.625 13.258 10.625 12.9163C10.625 12.5747 10.3417 12.2913 10 12.2913Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.b4d7ab258e4fa27eda4d6f6662676449.svg";
export { ForwardRef as ReactComponent };